import { InvalidAnswerReason } from '../../core/models/responses/invalid-answer-reason.enum';

export const InvalidAnswerMessages: Record<InvalidAnswerReason, string> = {
  [InvalidAnswerReason.Outro]: 'Ocorreu um erro inesperado ao recuperar a resposta para essa pergunta.',
  [InvalidAnswerReason.PerguntaAberta]: 'A pergunta não pode ser respondida apenas com sim ou não.',
  [InvalidAnswerReason.PerguntaAmbigua]: 'Pergunta ambígua, ela pode ser respondida tanto com quanto com não.',
  [InvalidAnswerReason.ConteudoInadequado]:
    'A pergunta possui um conteúdo inadequado que fere os nossos termos de uso.',
  [InvalidAnswerReason.RespostaImprecisa]:
    'Não foi possível identificar uma resposta precisa para essa pergunta.',
  [InvalidAnswerReason.LimitePerguntasAtingido]: 'Limite de perguntas atingido, faça um palpite',
};
